import PptxGenJS from 'pptxgenjs';
import { toBulletRuns } from '../helpers';
import {
    addConfidentialDisclaimer,
    addProjectBadge,
    addBulletsSection,
    addSlideTitle,
    regularSlideGradient,
} from '../template-parts';
import { LabelValue } from '@/features/files/types';
import { PPTImageManager } from '../helpers/image-manager';

interface ProjectSections {
    landRights?: LabelValue[];
    capexAndOpex?: LabelValue[];
    otherInfo?: LabelValue[];
}

interface OtherInfoData {
    projectTitle?: string;
    logoBlack?: string;
    project: ProjectSections;
}

const positioning = {
    hBody: 1.48,
    land: {
        yTitle: 1.71,
        yBody: 2.04,
    },
    capex: {
        yTitle: 4.96,
        yBody: 5.26,
    },
    info: {
        yTitle: 8.2,
        yBody: 8.5,
    }
}
export function otherInfoSlide(pptx: PptxGenJS, data: OtherInfoData, imageManager: PPTImageManager) {

    const slide = pptx.addSlide();
    const slideImages = {
        logoBlack: imageManager.get('logo-black'),
        landRights: imageManager.get('land'),
        capexOpex: imageManager.get('settings'),
        otherInfo: imageManager.get('info')
    }
    const { hBody, land, capex, info } = positioning;
    const { landRights = [], capexAndOpex = [], otherInfo = [] } = data.project ?? {};


    // === 1) Background gradient ===
    regularSlideGradient(slide);

    // === 2) Logo black ===
    if (slideImages.logoBlack) {
        slide.addImage({
            data: slideImages.logoBlack,
            x: 5.26,
            y: 0.24,
            w: 1.92,
            h: 0.58,
        });
    }

    // === 3) Badge PROJECT XXX
    const badgeText = (data.projectTitle ?? 'PROJECT XXX').toUpperCase();
    addProjectBadge(slide, badgeText);

    // === 4) Title About the seller ===
    addSlideTitle(slide, 'Project XXX');

    // === 5) Content ===
    const landRightsBullets = toBulletRuns(landRights);
    const capexAndOpexBullets = toBulletRuns(capexAndOpex);
    const otherInfoBullets = toBulletRuns(otherInfo);

    addBulletsSection(slide, 'Land Rights', landRightsBullets, land.yTitle, land.yBody, hBody, slideImages.landRights);

    addBulletsSection(slide, 'Capex & Opex', capexAndOpexBullets, capex.yTitle, capex.yBody, hBody, slideImages.capexOpex);

    addBulletsSection(slide, 'Other Information', otherInfoBullets, info.yTitle, info.yBody, hBody, slideImages.otherInfo);

    // Confidential disclaimer
    addConfidentialDisclaimer(slide);
}
